import Axios from "axios";
import {
    SET_SALARY_AGING_REPORT_LIST, 
    UNSET_SALARY_AGING_REPORT_LIST
} from "@/store/mutation-types";
import {
    getSalaryAgingReport,
} from "@/store/api";

const state = {
    getSalaryAgingReport: [],
};

const getters = {
    getSalaryAgingReport(state) {
        return state.getSalaryAgingReport;
    },
};

const mutations = {
    [SET_SALARY_AGING_REPORT_LIST](state, data) {
        state.getSalaryAgingReport = data;
    },
    [UNSET_SALARY_AGING_REPORT_LIST](state) {
        state.getSalaryAgingReport = [];
    },
};

const actions = {

    getSalaryAgingReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getSalaryAgingReport}`, { params: data })
                .then((response) => {
                    commit(SET_SALARY_AGING_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_SALARY_AGING_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};